import { render, staticRenderFns } from "./SchaefflerFooter.vue?vue&type=template&id=0e9ebddd&scoped=true"
import script from "./SchaefflerFooter.vue?vue&type=script&lang=js"
export * from "./SchaefflerFooter.vue?vue&type=script&lang=js"
import style0 from "./SchaefflerFooter.vue?vue&type=style&index=0&id=0e9ebddd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9ebddd",
  null
  
)

export default component.exports